import classnames from "classnames";
import React from "react";
import { ProductAddButton } from "src/components";
import { mapPrismicProductToProduct } from "src/services/mapperService";
import theme from "src/theme";
import styled from "styled-components";

import { Slice } from "../components";
import { ISliceAddToCart } from "../types";

const StyledProductAddButton = styled(ProductAddButton)`
  display: inline-block;
  width: initial;
  margin-top: ${theme.margins.marginBase};

  button {
    margin-top: 0;
  }
`;

export const AddToCart = ({
  slice_type,
  primary,
  items,
}: ISliceAddToCart): JSX.Element | null => {
  const {
    class_name: className,
    product: rawProduct,
    can_edit_quantity: canEditQuantity,
    button_label: label,
  } = primary;

  const product =
    rawProduct !== undefined && rawProduct !== null
      ? mapPrismicProductToProduct([rawProduct])[0]
      : undefined;

  if (!product) {
    return null;
  }

  return (
    <Slice className={classnames("slice-add-to-cart", className)} noGutter>
      <StyledProductAddButton
        product={product}
        canBeAddedToCart={true}
        canEditQuantity={canEditQuantity}
        label={label}
        fullWidth={false}
      />
    </Slice>
  );
};
